import { createClient } from 'contentful';

const SPACE_ID = 'w5ok1kxsorzp';
const ACCESS_TOKEN =
  '7757a292a70a0093bd05cda332aefe0d6a6277100be68f86d4347092d7a7b009';

const client = createClient({
  space: SPACE_ID,
  accessToken: ACCESS_TOKEN,
});

export default new Promise((resolve, reject) =>
  client
    .getEntry('1K2ogDHvik8MYmMsO0cMau')
    .then(resolve)
    .catch(reject)
);



// WEBPACK FOOTER //
// ./src/getStringsFromContentful.js